exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sku_info[data-v-1036ef0c]{font-size:12px;text-align:left;margin:5px}.sku_title[data-v-1036ef0c]{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2}.sku_price[data-v-1036ef0c]{font-size:14px}.sku_month[data-v-1036ef0c]{font-size:12px;text-align:right}.sku_tags[data-v-1036ef0c]{display:inline-block}.custom-indicator[data-v-1036ef0c]{position:absolute;right:5px;bottom:5px;padding:1px 7px;color:#fff;font-size:12px;background:rgba(0,0,0,.3)}", ""]);

// exports
